import {
  Duration__compareTo_impl_pchp0f1efu9z6fxx84c as Duration__compareTo_impl_pchp0f,
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__minus_impl_q5cfm72o3yxdmb1e42d as Duration__minus_impl_q5cfm7,
  Duration__toString_impl_8d916b1pmuuqkmfodll as Duration__toString_impl_8d916b,
  Duration__hashCode_impl_u4exz62capomnnb6e8m as Duration__hashCode_impl_u4exz6,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  now3ay3meoyffvdk as now,
  ResourceUse2vo6us5ch1uy1 as ResourceUse,
  uses26aso754i5iou as uses,
  InterruptibleDelay2c0xh0wdvl7bj as InterruptibleDelay,
  ensureTotal1k0kavd9th17q as ensureTotal,
} from './utils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  use25wcggkyjf1ad as use,
  plus39grgnv43k79 as plus,
} from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  launch1c91vkjzdi9sd as launch,
  asyncz02dsa2nb2zt as async,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { withTimeoutOrNull1yc5m6zc7bl9o as withTimeoutOrNull } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Timeout.mjs';
import {
  coerceAtLeast3jlgfquiyquc9 as coerceAtLeast,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  beginUse146s8dwmfk72s as beginUse,
  Reactive1jy75v4li6ldv as Reactive,
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  MutableReactive2qdhhyljdknhy as MutableReactive,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  boxApply1qmzdb3dh90hg as boxApply,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  asSequence2phdjljfh9jhx as asSequence,
  firstOrNull1982767dljvdy as firstOrNull,
  toSet2orjxp16sotqu as toSet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { filter184huxd00uyfg as filter } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { Companion_getInstance138pnyl3l6agm as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  lens27v59dqa1oc3r as lens_1,
  lensListenable3n4xxl63wcyqk as lensListenable,
} from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance_1,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
  ReactiveStatel8ixobo86msn as ReactiveState,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { WithTimestamp1a7xpvbvrfq5g as WithTimestamp } from './WithTimestamp.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  setOf1u3mizs95ngxo as setOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { awaitOnce3bs0u39jtmrli as awaitOnce } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { modification1bed5xcrmg3fq as modification } from '../../lightningdb/modification.diff.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { HasId24qpfucecockd as HasId } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { LimitReactiveList3fo42zjtyuog7 as LimitReactiveList } from './LimitReactiveList.mjs';
import {
  OnField2kq8b4gk936v8 as OnField,
  Inside34e21e5w7gmr5 as Inside,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { minus165a8u1e0x1lu as minus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { awaitAllfig2t8ybkmg8 as awaitAll } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import { coroutineScope2qhrb6lhutwsn as coroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { _id3hu92r6d2ylpm as _id } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasIdFields.mjs';
import { CoverageStore2039zzqixnpei as CoverageStore } from './CoverageStore.mjs';
import { ClientModelRestUpdatesWebSocket3jbuy8au3ubru as ClientModelRestUpdatesWebSocket } from '../../../../../lightning-server-typed-shared/com/lightningkite/lightningserver/typed/ClientModelRestEndpoints.mjs';
import { toTypedWebSocket14iamnuoa79fq as toTypedWebSocket } from '../networking/adapt.mjs';
import { SharedCollectionUpdatesSocket32e1skqgvgdc7 as SharedCollectionUpdatesSocket } from './SharedCollectionUpdatesSocket.mjs';
import { BatchAndQueue1zjqkogt1zg44 as BatchAndQueue } from './BatchAndQueue.mjs';
import {
  item$default3bjnrg54mh16v as item$default,
  list$defaultxdc7qn6p0xfr as list$default,
  getejg6weymx5xn as get,
  querywyj590i3eimd as query,
  watchfa0nguk2p1l7 as watch,
  watchq159bzxd0s4v as watch_0,
  ModelCacheLike1q3b58tuu7jn2 as ModelCacheLike,
} from './ModelCacheLike.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function acceptableOnArrival($this, $receiver) {
  return $this.isLive_ksy7m5_k$($receiver) || Duration__compareTo_impl_pchp0f($this.enteredAt_1.minus_bn4aoq_k$($receiver.at_1), $this.maximumAge_1) < 0;
}
function freshWithin($this, $receiver, window_0) {
  return $this.isLive_ksy7m5_k$($receiver) || Duration__compareTo_impl_pchp0f(now($this.$this_1.scope_1).minus_bn4aoq_k$($receiver.at_1), window_0) < 0;
}
function *fetchInBackground($this, $completion) {
  try {
    yield* $this.fetch_u79r6r_k$($completion);
  } catch ($p) {
    if ($p instanceof CancellationException()) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Exception()) {
        var e_0 = $p;
        var tmp0_safe_receiver = $this.get_log_18j19h_k$();
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$(['Fetch failed: ' + e_0.toString()]);
        }
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function _get_observed__9uzlkt($this) {
  var tmp0 = $this.observed$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('observed', 1, tmp, ModelCache$SelfRefreshing$_get_observed_$ref_rpnyfs(), null);
  return tmp0.get_value_j01efc_k$();
}
function ModelCache$SelfRefreshing$fetch$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.retrieve_54hhln_k$($completion);
    return Unit_instance;
  }), 0);
}
function ModelCache$SelfRefreshing$refreshing$slambda$lambda$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var tmp0_safe_receiver = this$0.get_log_18j19h_k$();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.log_iyb52q_k$(['Fetching after socket connected']);
    }
    yield* /*#__NOINLINE__*/fetchInBackground(this$0, $completion);
    return Unit_instance;
  }), 1);
}
function ModelCache$SelfRefreshing$refreshing$slambda$slambda($socket) {
  return constructCallableReference(($this$withTimeoutOrNull, $completion) => orPromise($completion, function *($completion) {
    yield* $socket.wait_bz3vni_k$($completion);
    return Unit_instance;
  }), 1);
}
function ModelCache$SelfRefreshing$refreshing$slambda(this$0, this$1) {
  return constructCallableReference(($this$ResourceUse, $completion) => orPromise($completion, function *($completion) {
    onRemove($this$ResourceUse, () => {
      var tmp0_safe_receiver = this$0.get_log_18j19h_k$();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.log_iyb52q_k$(['No longer needed']);
      }
      return Unit_instance;
    });
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(30, DurationUnit_SECONDS_getInstance());
    if (Duration__compareTo_impl_pchp0f(this$0.pullFrequency_1, tmp$ret$0) < 0) {
      tmp_0 = !(this$1.sockets_1 == null);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp0_safe_receiver = this$0.get_log_18j19h_k$();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.log_iyb52q_k$(['Using socket']);
      }
      // Inline function 'kotlin.also' call
      var this_0 = this$1.sockets_1.require_jxou15_k$(this$0.get_socketCondition_ypkvz_k$());
      var r = this_0;
      use($this$ResourceUse, r);
      onRemove($this$ResourceUse, r.satisfied_1.addListener_6y9mct_k$(() => {
        var tmp;
        if (r.satisfied_1.get_value_j01efc_k$()) {
          launch($this$ResourceUse, VOID, VOID, ModelCache$SelfRefreshing$refreshing$slambda$lambda$slambda(this$0));
          tmp = Unit_instance;
        }
        return Unit_instance;
      }));
      tmp = this_0;
    } else {
      tmp = null;
    }
    var socket = tmp;
    var tmp1_safe_receiver = this$0.cached_mmi02m_k$();
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = (freshWithin(this$0, tmp1_safe_receiver, this$0.maximumAge_1) && !this$0.needsMore_i37c0i_k$());
    }
    var acceptable = tmp_1 === true;
    if (acceptable) {
      var tmp2_safe_receiver = this$0.get_log_18j19h_k$();
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.log_iyb52q_k$(['Found existing value']);
      }
    } else {
      if (!(socket == null)) {
        var tmp3_safe_receiver = this$0.get_log_18j19h_k$();
        if (tmp3_safe_receiver == null)
          null;
        else {
          tmp3_safe_receiver.log_iyb52q_k$(['Waiting for socket to connect...']);
        }
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance();
        var tmp_2 = toDuration(5, DurationUnit_SECONDS_getInstance());
        if ((yield* withTimeoutOrNull(tmp_2, ModelCache$SelfRefreshing$refreshing$slambda$slambda(socket), $completion)) == null) {
          var tmp5_safe_receiver = this$0.get_log_18j19h_k$();
          if (tmp5_safe_receiver == null)
            null;
          else {
            tmp5_safe_receiver.log_iyb52q_k$(['Socket did not connect']);
          }
        }
      }
      var tmp6_safe_receiver = this$0.get_log_18j19h_k$();
      if (tmp6_safe_receiver == null)
        null;
      else {
        tmp6_safe_receiver.log_iyb52q_k$(['Initial fetch']);
      }
      yield* /*#__NOINLINE__*/fetchInBackground(this$0, $completion);
    }
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var floor = toDuration(5, DurationUnit_SECONDS_getInstance());
    // Inline function 'kotlin.takeIf' call
    var this_1 = new (Duration())(this$0.pullFrequency_1);
    var tmp_3;
    var it = this_1.rawValue_1;
    if (Duration__compareTo_impl_pchp0f(it, Companion_getInstance().ZERO_1) > 0) {
      tmp_3 = this_1;
    } else {
      tmp_3 = null;
    }
    var tmp_4 = tmp_3;
    var tmp7_safe_receiver = tmp_4 == null ? null : tmp_4.rawValue_1;
    var tmp_5;
    var tmp_6 = tmp7_safe_receiver;
    if ((tmp_6 == null ? null : new (Duration())(tmp_6)) == null) {
      tmp_5 = null;
    } else {
      tmp_5 = coerceAtLeast(new (Duration())(tmp7_safe_receiver), new (Duration())(floor)).rawValue_1;
    }
    var cadence = tmp_5;
    var tmp_7;
    if (!(socket == null)) {
      var tmp_8;
      var tmp_9 = cadence;
      if ((tmp_9 == null ? null : new (Duration())(tmp_9)) == null) {
        tmp_8 = floor;
      } else {
        tmp_8 = cadence;
      }
      tmp_7 = tmp_8;
    } else {
      tmp_7 = cadence;
    }
    var whileUncovered = tmp_7;
    while (true) {
      var held = this$0.cached_mmi02m_k$();
      var tmp_10;
      if (held == null || this$0.needsMore_i37c0i_k$()) {
        tmp_10 = Companion_getInstance().ZERO_1;
      } else if (this$0.isLive_ksy7m5_k$(held)) {
        tmp_10 = null;
      } else {
        var tmp_11;
        var tmp_12 = whileUncovered;
        if ((tmp_12 == null ? null : new (Duration())(tmp_12)) == null) {
          tmp_11 = null;
        } else {
          tmp_11 = Duration__minus_impl_q5cfm7(whileUncovered, now(this$1.scope_1).minus_bn4aoq_k$(held.at_1));
        }
        tmp_10 = tmp_11;
      }
      var wait = tmp_10;
      var tmp_13 = wait;
      if ((tmp_13 == null ? null : new (Duration())(tmp_13)) == null) {
        var tmp10_safe_receiver = this$0.get_log_18j19h_k$();
        if (tmp10_safe_receiver == null)
          null;
        else {
          tmp10_safe_receiver.log_iyb52q_k$(['Nothing to refresh for']);
        }
        yield* this$0.interrupt_1.delay_93os7b_k$(floor, $completion);
      } else {
        if (Duration__compareTo_impl_pchp0f(wait, Companion_getInstance().ZERO_1) > 0) {
          var tmp11_safe_receiver = this$0.get_log_18j19h_k$();
          if (tmp11_safe_receiver == null)
            null;
          else {
            tmp11_safe_receiver.log_iyb52q_k$(['No need to pull for ' + Duration__toString_impl_8d916b(wait)]);
          }
          yield* this$0.interrupt_1.delay_93os7b_k$(wait, $completion);
        } else {
          var tmp12_safe_receiver = this$0.get_log_18j19h_k$();
          if (tmp12_safe_receiver == null)
            null;
          else {
            tmp12_safe_receiver.log_iyb52q_k$(['Needs pull, starting']);
          }
          yield* /*#__NOINLINE__*/fetchInBackground(this$0, $completion);
          var tmp_14;
          var tmp_15 = cadence;
          if ((tmp_15 == null ? null : new (Duration())(tmp_15)) == null) {
            tmp_14 = floor;
          } else {
            tmp_14 = cadence;
          }
          yield* this$0.interrupt_1.delay_93os7b_k$(tmp_14, $completion);
        }
      }
    }
    return Unit_instance;
  }), 1);
}
var ModelCache$SelfRefreshing$processWhileRunning$1Class;
function ModelCache$SelfRefreshing$processWhileRunning$1() {
  if (ModelCache$SelfRefreshing$processWhileRunning$1Class === VOID) {
    class $ {
      constructor(this$0, this$1) {
        this.this$0__1 = this$0;
        this.this$1__1 = this$1;
      }
      beginUse_omrbby_k$() {
        this.this$0__1.enteredAt_1 = now(this.this$1__1.scope_1);
        return this.this$0__1.refreshing_1.beginUse_omrbby_k$();
      }
    }
    initMetadataForClass($);
    ModelCache$SelfRefreshing$processWhileRunning$1Class = $;
  }
  return ModelCache$SelfRefreshing$processWhileRunning$1Class;
}
var ModelCache$SelfRefreshing$observed$2$1Class;
function ModelCache$SelfRefreshing$observed$2$1() {
  if (ModelCache$SelfRefreshing$observed$2$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
      }
      get_state_wc71wk_k$() {
        return this.this$0__1.get_state_wc71wk_k$();
      }
      get_state_wc71uu_k$() {
        return this.get_state_wc71wk_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.this$0__1.get_changes_dhi2my_k$().addListener_6y9mct_k$(listener);
      }
    }
    protoOf($).beginUse_omrbby_k$ = beginUse;
    initMetadataForClass($, VOID, VOID, VOID, [Reactive()]);
    ModelCache$SelfRefreshing$observed$2$1Class = $;
  }
  return ModelCache$SelfRefreshing$observed$2$1Class;
}
function ModelCache$SelfRefreshing$observed$delegate$lambda$lambda(it) {
  return it;
}
function ModelCache$SelfRefreshing$_get_observed_$ref_rpnyfs() {
  return constructCallableReference((p0) => _get_observed__9uzlkt(p0), 1, 0, 181);
}
function ModelCache$SelfRefreshing$_get_lastUpdatedAt_$ref_mji5mq() {
  return constructCallableReference((p0) => p0.get_lastUpdatedAt_7wjlf3_k$(), 1, 0, 182);
}
function socketCoveredSince($this, timestamp, matches) {
  var tmp0_safe_receiver = $this.sockets_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.listeningStatus_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_value_j01efc_k$();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.requirements_1;
  var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : asSequence(tmp3_safe_receiver);
  var tmp;
  if (tmp4_safe_receiver == null) {
    tmp = null;
  } else {
    tmp = filter(tmp4_safe_receiver, (it) => matches(it.condition_1));
  }
  var tmp5_safe_receiver = tmp;
  var tmp_0;
  if (tmp5_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.sequences.minOfOrNull' call
      var iterator = tmp5_safe_receiver.iterator_jk1svi_k$();
      if (!iterator.hasNext_bitz1p_k$()) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var tmp0_elvis_lhs = iterator.next_20eer_k$().coveredSince_1;
      var minValue = tmp0_elvis_lhs == null ? Companion_getInstance_0().get_DISTANT_FUTURE_gftwmi_k$() : tmp0_elvis_lhs;
      while (iterator.hasNext_bitz1p_k$()) {
        var tmp0_elvis_lhs_0 = iterator.next_20eer_k$().coveredSince_1;
        var v = tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().get_DISTANT_FUTURE_gftwmi_k$() : tmp0_elvis_lhs_0;
        if (compareTo(minValue, v) > 0) {
          minValue = v;
        }
      }
      tmp$ret$0 = minValue;
    }
    tmp_0 = tmp$ret$0;
  }
  var tmp6_safe_receiver = tmp_0;
  var tmp_1;
  if (tmp6_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = timestamp.compareTo_stdc3w_k$(tmp6_safe_receiver) > 0;
  }
  return tmp_1 === true;
}
var SelfRefreshingClass;
function SelfRefreshing() {
  if (SelfRefreshingClass === VOID) {
    class $_0 {
      constructor($outer, maximumAge, pullFrequency, $box) {
        boxApply(this, $box);
        this.$this_1 = $outer;
        this.maximumAge_1 = maximumAge;
        this.pullFrequency_1 = pullFrequency;
        this.interrupt_1 = this.$this_1.interrupt_1.child_1kc9wc_k$();
        this.fetchError_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
        this.enteredAt_1 = Companion_getInstance_0().get_DISTANT_PAST_yzdqbd_k$();
        var tmp = this;
        tmp.refreshing_1 = ResourceUse(this.$this_1.scope_1, ModelCache$SelfRefreshing$refreshing$slambda(this, this.$this_1));
        var tmp_0 = this;
        tmp_0.processWhileRunning_1 = new (ModelCache$SelfRefreshing$processWhileRunning$1())(this, this.$this_1);
        var tmp_1 = this;
        tmp_1.observed$delegate_1 = lazy(() => {
          var tmp = new (ModelCache$SelfRefreshing$observed$2$1())(this);
          return uses(lens_1(tmp, ModelCache$SelfRefreshing$observed$delegate$lambda$lambda), this.processWhileRunning_1);
        });
        var tmp_2 = this;
        tmp_2.lastUpdatedAt$delegate_1 = lazy(() => {
          var tmp = this.get_changes_dhi2my_k$();
          return lensListenable(tmp, () => {
            var tmp0_safe_receiver = this.cached_mmi02m_k$();
            return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.at_1;
          });
        });
      }
      needsMore_i37c0i_k$() {
        return false;
      }
      get_changes_dhi2my_k$() {
        return this.$this_1.store_1.updates_1;
      }
      *fetch_u79r6r_k$($completion) {
        return yield* this.recordingOutcome_ll4slo_k$(ModelCache$SelfRefreshing$fetch$slambda(this), $completion);
      }
      *recordingOutcome_ll4slo_k$(action, $completion) {
        try {
          // Inline function 'kotlin.also' call
          var this_0 = yield* $(action($completion), $completion);
          this.fetchError_1.set_value_v1vabv_k$(null);
          return this_0;
        } catch ($p) {
          if ($p instanceof CancellationException()) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              this.fetchError_1.set_value_v1vabv_k$(e_0);
              throw e_0;
            } else {
              throw $p;
            }
          }
        }
      }
      get_state_wc71wk_k$() {
        var held = this.cached_mmi02m_k$();
        if (!(held == null) && acceptableOnArrival(this, held)) {
          var tmp0_safe_receiver = this.fetchError_1.get_value_j01efc_k$();
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.takeIf' call
            var tmp_0;
            if (!freshWithin(this, held, this.maximumAge_1)) {
              tmp_0 = tmp0_safe_receiver;
            } else {
              tmp_0 = null;
            }
            tmp = tmp_0;
          }
          var tmp1_safe_receiver = tmp;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            return Companion_getInstance_1().exception_iibuh2_k$(tmp1_safe_receiver);
          }
          return _ReactiveState___init__impl__fvdp9b(held.item_1);
        }
        var tmp2_safe_receiver = this.fetchError_1.get_value_j01efc_k$();
        var tmp_1;
        if (tmp2_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_1 = Companion_getInstance_1().exception_iibuh2_k$(tmp2_safe_receiver);
        }
        var tmp3_elvis_lhs = tmp_1;
        var tmp_2;
        var tmp_3 = tmp3_elvis_lhs;
        if ((tmp_3 == null ? null : new (ReactiveState())(tmp_3)) == null) {
          tmp_2 = Companion_getInstance_1().notReady_1;
        } else {
          tmp_2 = tmp3_elvis_lhs;
        }
        return tmp_2;
      }
      get_state_wc71uu_k$() {
        return this.get_state_wc71wk_k$();
      }
      addListener_6y9mct_k$(listener) {
        return plus(_get_observed__9uzlkt(this), this.fetchError_1).addListener_6y9mct_k$(listener);
      }
      get_lastUpdatedAt_7wjlf3_k$() {
        var tmp0 = this.lastUpdatedAt$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('lastUpdatedAt', 1, tmp, ModelCache$SelfRefreshing$_get_lastUpdatedAt_$ref_mji5mq(), null);
        return tmp0.get_value_j01efc_k$();
      }
      interruptPolling_yzwr2o_k$() {
        return this.interrupt_1.interrupt_6jhqqb_k$();
      }
    }
    protoOf($_0).beginUse_omrbby_k$ = beginUse;
    initMetadataForClass($_0, 'SelfRefreshing', VOID, VOID, [Reactive()], [0, 1]);
    SelfRefreshingClass = $_0;
  }
  return SelfRefreshingClass;
}
var ModelCacheItemReadableImplClass;
function ModelCacheItemReadableImpl() {
  if (ModelCacheItemReadableImplClass === VOID) {
    class $ extends SelfRefreshing() {
      constructor($outer, id, maximumAge, pullFrequency, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_2 = $outer;
        super($outer, maximumAge, pullFrequency, $box);
        this.id_1 = id;
        var tmp = this;
        var tmp0_safe_receiver = this.$this_2.log_1;
        tmp.log_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tag_ioihsw_k$(toString(this.id_1));
        this.query_1 = this.$this_2.store_1.idQuery_k1til4_k$(this.id_1);
      }
      get_log_18j19h_k$() {
        return this.log_1;
      }
      get_socketCondition_ypkvz_k$() {
        return this.query_1.condition_1;
      }
      cached_mmi02m_k$() {
        var tmp0_safe_receiver = this.$this_2.store_1.known_ahtola_k$(this.query_1);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = new (WithTimestamp())(firstOrNull(tmp0_safe_receiver.items_1), tmp0_safe_receiver.at_1);
        }
        return tmp;
      }
      *retrieve_54hhln_k$($completion) {
        yield* this.$this_2.multiget_1.invoke_nzm626_k$(this.id_1, $completion);
        return Unit_instance;
      }
      isLive_9fyg02_k$(cached) {
        var tmp0_elvis_lhs = cached.item_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var item = tmp;
        return socketCoveredSince(this.$this_2, cached.at_1, (it) => it.invoke_wbynzd_k$(item));
      }
      isLive_ksy7m5_k$(cached) {
        return this.isLive_9fyg02_k$(cached);
      }
      *modify_ff53f_k$(modification, $completion) {
        // Inline function 'kotlin.also' call
        var this_0 = yield* this.$this_2.skipCache_1.modify_ntk3hh_k$(this.id_1, modification, $completion);
        this.$this_2.store_1.mutated_37iclx_k$(listOf(this_0), now(this.$this_2.scope_1));
        return this_0;
      }
      *delete_4td7nw_k$($completion) {
        yield* this.$this_2.skipCache_1.delete_xs5ou5_k$(this.id_1, $completion);
        deletionRecorded(this.$this_2, setOf(this.id_1));
        return Unit_instance;
      }
      *set_yehbsy_k$(value, $completion) {
        if (value == null)
          return yield* this.delete_4td7nw_k$($completion);
        var existing = yield* awaitOnce(this, $completion);
        var tmp;
        if (existing == null) {
          tmp = yield* this.$this_2.skipCache_1.insert_a1u7p6_k$(value, $completion);
        } else {
          var tmp0_safe_receiver = modification(this.$this_2.serializer_1, existing, value);
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = yield* this.$this_2.skipCache_1.modify_ntk3hh_k$(this.id_1, tmp0_safe_receiver, $completion);
          }
          tmp = tmp_0;
        }
        var updated = tmp;
        if (updated == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this.$this_2.store_1.mutated_37iclx_k$(listOf(updated), now(this.$this_2.scope_1));
        }
        return Unit_instance;
      }
      set_revjhg_k$(value, $completion) {
        return this.set_yehbsy_k$((value == null ? true : isInterface(value, HasId())) ? value : THROW_CCE(), $completion);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof ModelCacheItemReadableImpl()) {
          tmp_1 = equals(this.id_1, other.id_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = equals(new (Duration())(this.maximumAge_1), new (Duration())(other.maximumAge_1));
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals(new (Duration())(this.pullFrequency_1), new (Duration())(other.pullFrequency_1));
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return (hashCode(this.id_1) + Duration__hashCode_impl_u4exz6(this.maximumAge_1) | 0) + Duration__hashCode_impl_u4exz6(this.pullFrequency_1) | 0;
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, 'ModelCacheItemReadableImpl', VOID, VOID, [MutableReactive(), Reactive()], [0, 1]);
    ModelCacheItemReadableImplClass = $;
  }
  return ModelCacheItemReadableImplClass;
}
var ModelCacheLimitReadableImplClass;
function ModelCacheLimitReadableImpl() {
  if (ModelCacheLimitReadableImplClass === VOID) {
    class $ extends SelfRefreshing() {
      constructor($outer, query, maximumAge, pullFrequency, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_2 = $outer;
        super($outer, maximumAge, pullFrequency, $box);
        this.query_1 = query;
        var tmp = this;
        var tmp0_safe_receiver = this.$this_2.log_1;
        tmp.log_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tag_ioihsw_k$(toString(this.query_1.condition_1) + ' ' + toString(this.query_1.orderBy_1));
        this.currentQuery_1 = this.query_1;
      }
      get_log_18j19h_k$() {
        return this.log_1;
      }
      get_socketCondition_ypkvz_k$() {
        return this.query_1.condition_1;
      }
      cached_mmi02m_k$() {
        var tmp0_safe_receiver = this.$this_2.store_1.known_ahtola_k$(this.currentQuery_1);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = new (WithTimestamp())(tmp0_safe_receiver.items_1, tmp0_safe_receiver.at_1);
        }
        return tmp;
      }
      isLive_rgokdv_k$(cached) {
        return socketCoveredSince(this.$this_2, cached.at_1, (it) => it.equals(this.query_1.condition_1));
      }
      isLive_ksy7m5_k$(cached) {
        return this.isLive_rgokdv_k$(cached);
      }
      needsMore_i37c0i_k$() {
        var tmp0_safe_receiver = this.$this_2.store_1.known_ahtola_k$(this.currentQuery_1);
        return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.partial_1) === true;
      }
      *retrieve_54hhln_k$($completion) {
        yield* this.$this_2.queryInternal_1.invoke_nzm626_k$(this.currentQuery_1, $completion);
        return Unit_instance;
      }
      set_limit_mo5fx2_k$(value) {
        // Inline function 'kotlin.require' call
        if (!(value > 0)) {
          var message = 'A limit of ' + value + ' asks the server for nothing.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        this.currentQuery_1 = this.currentQuery_1.copy$default_rbh2y2_k$(VOID, VOID, VOID, value);
        this.interruptPolling_yzwr2o_k$();
      }
      get_limit_iuokuq_k$() {
        return this.currentQuery_1.limit_1;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof ModelCacheLimitReadableImpl()) {
          tmp_1 = this.query_1.equals(other.query_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = equals(new (Duration())(this.maximumAge_1), new (Duration())(other.maximumAge_1));
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals(new (Duration())(this.pullFrequency_1), new (Duration())(other.pullFrequency_1));
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return (this.query_1.hashCode() + Duration__hashCode_impl_u4exz6(this.maximumAge_1) | 0) + Duration__hashCode_impl_u4exz6(this.pullFrequency_1) | 0;
      }
    }
    initMetadataForClass($, 'ModelCacheLimitReadableImpl', VOID, VOID, [LimitReactiveList(), Reactive()], [0, 1]);
    ModelCacheLimitReadableImplClass = $;
  }
  return ModelCacheLimitReadableImplClass;
}
function deletionRecorded($this, ids) {
  $this.store_1.deleted_qylqew_k$(ids, now($this.scope_1));
  $this.interrupt_1.interrupt_6jhqqb_k$();
}
function ModelCache$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    try {
      this$0.store_1.useMasking_atm68g_k$((yield* this$0.skipCache_1.permissions_x4pqz_k$($completion)).readMask_1);
      this$0.interrupt_1.interrupt_6jhqqb_k$();
    } catch ($p) {
      if ($p instanceof CancellationException()) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Exception()) {
          var e_0 = $p;
          var tmp0_safe_receiver = this$0.log_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.log_iyb52q_k$(['Could not read permissions, so masked sorts stay conservative: ' + e_0.toString()]);
          }
        } else {
          throw $p;
        }
      }
    }
    return Unit_instance;
  }), 1);
}
function ModelCache$multiget$slambda(this$0) {
  return constructCallableReference((ids, $completion) => orPromise($completion, function *($completion) {
    var at = now(this$0.scope_1);
    var found = yield* this$0.skipCache_1.query_o986pg_k$(new (Query())(OnField().new_com_lightningkite_services_database_Condition_OnField_tgn7de_k$(this$0.idProp_1, Inside().new_com_lightningkite_services_database_Condition_Inside_16ypu3_k$(ids)), VOID, VOID, ids.get_size_woubt6_k$()), $completion);
    var tmp = toSet(ids);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
    var _iterator__ex2g4s = found.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$1 = item.get__id_18jb1r_k$();
      destination.add_utx5q5_k$(tmp$ret$1);
    }
    this$0.store_1.identified_ppvmce_k$(found, minus(tmp, destination), at);
    // Inline function 'kotlin.collections.associateBy' call
    var capacity = coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(found, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
    var _iterator__ex2g4s_0 = found.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp$ret$4 = element.get__id_18jb1r_k$();
      destination_0.put_4fpzoq_k$(tmp$ret$4, element);
    }
    var map = destination_0;
    // Inline function 'kotlin.collections.map' call
    var this_0 = ids;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s_1 = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var item_0 = _iterator__ex2g4s_1.next_20eer_k$();
      var tmp$ret$7 = map.get_wei43m_k$(item_0);
      destination_1.add_utx5q5_k$(tmp$ret$7);
    }
    return destination_1;
  }), 1);
}
function ModelCache$queryInternal$slambda$slambda$slambda(this$0, $query) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var at = now(this$0.scope_1);
    // Inline function 'kotlin.also' call
    var this_0 = yield* this$0.skipCache_1.query_o986pg_k$($query, $completion);
    this$0.store_1.queried$default_py8gr4_k$($query, this_0, at);
    return this_0;
  }), 1);
}
function ModelCache$queryInternal$slambda$slambda($queries, this$0) {
  return constructCallableReference(($this$coroutineScope, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $queries;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$2 = async($this$coroutineScope, VOID, VOID, ModelCache$queryInternal$slambda$slambda$slambda(this$0, item));
      destination.add_utx5q5_k$(tmp$ret$2);
    }
    return yield* awaitAll(destination, $completion);
  }), 1);
}
function ModelCache$queryInternal$slambda(this$0) {
  return constructCallableReference((queries, $completion) => orPromise($completion, function *($completion) {
    return yield* coroutineScope(ModelCache$queryInternal$slambda$slambda(queries, this$0), $completion);
  }), 1);
}
var ModelCacheClass;
function ModelCache() {
  if (ModelCacheClass === VOID) {
    class $ {
      constructor(skipCache, serializer, scope, log, versionOf) {
        scope = scope === VOID ? get_AppScope() : scope;
        log = log === VOID ? null : log;
        versionOf = versionOf === VOID ? null : versionOf;
        this.skipCache_1 = skipCache;
        this.serializer_1 = serializer;
        this.scope_1 = scope;
        this.log_1 = log;
        this.idProp_1 = _id(this.serializer_1);
        this.store_1 = new (CoverageStore())(this.serializer_1, versionOf);
        launch(this.scope_1, VOID, VOID, ModelCache$slambda(this));
        this.interrupt_1 = new (InterruptibleDelay())();
        var tmp = this;
        var tmp_0 = this.skipCache_1;
        var tmp0_safe_receiver = isInterface(tmp_0, ClientModelRestUpdatesWebSocket()) ? tmp_0 : null;
        var tmp_1;
        if (tmp0_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp1_scope = this.scope_1;
          var tmp2_socket = toTypedWebSocket(tmp0_safe_receiver.updates_3vknjq_k$());
          var tmp0_safe_receiver_0 = this.log_1;
          var tmp3_log = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.tag_ioihsw_k$('Sockets');
          tmp_1 = new (SharedCollectionUpdatesSocket())(tmp1_scope, tmp2_socket, (update) => {
            var tmp;
            if (update.overload_1) {
              this.store_1.invalidate_p4aufp_k$();
              this.interrupt_1.interrupt_6jhqqb_k$();
              tmp = Unit_instance;
            } else {
              var tmp_0 = now(this.scope_1);
              this.store_1.socketDelta_xhb3vg_k$(update.updates_1, update.remove_1, tmp_0, (condition, since) => socketCoveredSince(this, since, (it) => it.equals(condition)));
              var tmp_1;
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!update.remove_1.isEmpty_y1axqb_k$()) {
                this.interrupt_1.interrupt_6jhqqb_k$();
                tmp_1 = Unit_instance;
              }
              tmp = tmp_1;
            }
            return Unit_instance;
          }, tmp3_log);
        }
        tmp.sockets_1 = tmp_1;
        var tmp_2 = this;
        var tmp0_safe_receiver_1 = this.log_1;
        var tmp_3 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.tag_ioihsw_k$('multiget');
        tmp_2.multiget_1 = new (BatchAndQueue())(this.scope_1, VOID, tmp_3, ModelCache$multiget$slambda(this));
        var tmp_4 = this;
        var tmp0_safe_receiver_2 = this.log_1;
        var tmp_5 = tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.tag_ioihsw_k$('queryInternal');
        tmp_4.queryInternal_1 = new (BatchAndQueue())(this.scope_1, VOID, tmp_5, ModelCache$queryInternal$slambda(this));
      }
      item_eropyg_k$(id, maximumAge, pullFrequency) {
        return new (ModelCacheItemReadableImpl())(this, id, maximumAge, pullFrequency);
      }
      list_wx6i37_k$(query, maximumAge, pullFrequency) {
        // Inline function 'kotlin.require' call
        if (!(query.skip_1 === 0)) {
          var message = 'ModelCache cannot cache a query with skip; page with limit() instead.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(query.limit_1 > 0)) {
          var message_0 = 'ModelCache needs a positive limit; a limit of ' + query.limit_1 + ' asks the server for nothing.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        return new (ModelCacheLimitReadableImpl())(this, query.copy$default_rbh2y2_k$(VOID, ensureTotal(query.orderBy_1, this.serializer_1)), maximumAge, pullFrequency);
      }
      *add_co22jy_k$(item, $completion) {
        // Inline function 'kotlin.also' call
        var this_0 = yield* this.skipCache_1.insert_a1u7p6_k$(item, $completion);
        this.store_1.mutated_37iclx_k$(listOf(this_0), now(this.scope_1));
        return this_0;
      }
      *addAll_zaft0n_k$(items, $completion) {
        // Inline function 'kotlin.also' call
        var this_0 = yield* this.skipCache_1.insertBulk_vz3d8k_k$(items, $completion);
        this.store_1.mutated_37iclx_k$(this_0, now(this.scope_1));
        return this_0;
      }
      *bulkModify_ugvnv2_k$(bulkUpdate, $completion) {
        // Inline function 'kotlin.also' call
        var this_0 = yield* this.skipCache_1.bulkModify_ugvnv2_k$(bulkUpdate, $completion);
        this.store_1.invalidate_p4aufp_k$();
        this.interrupt_1.interrupt_6jhqqb_k$();
        return this_0;
      }
      *totallyInvalidate_d4stw5_k$($completion) {
        this.store_1.invalidate_p4aufp_k$();
        this.interrupt_1.interrupt_6jhqqb_k$();
        return Unit_instance;
      }
      localInsert_9xyne_k$(item) {
        this.store_1.mutated_37iclx_k$(listOf(item), now(this.scope_1));
        return item;
      }
    }
    protoOf($).item$default_6j9a06_k$ = item$default;
    protoOf($).list$default_sjz00l_k$ = list$default;
    protoOf($).get_6ueaa7_k$ = get;
    protoOf($).query_so6xq1_k$ = query;
    protoOf($).watch_h7bemi_k$ = watch;
    protoOf($).watch_jonktu_k$ = watch_0;
    initMetadataForClass($, 'ModelCache', VOID, VOID, [ModelCacheLike()], [1, 0]);
    ModelCacheClass = $;
  }
  return ModelCacheClass;
}
//region block: exports
export {
  ModelCache as ModelCache1j2q0r8bmhrox,
};
//endregion

//# sourceMappingURL=ModelCache.mjs.map
